import React__default, { useRef, useEffect } from 'react';
import { IlIcon } from '../IlIcon/index.js';

/* eslint-disable */
function IlDataTableV3Checkbox(props) {
  var ref = useRef();
  useEffect(function () {
    ref.current.indeterminate = props.indeterminate;
  }, [props.indeterminate]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: ["IlDataTableV3Checkbox", props.checked ? "checked" : ""].join(" ")
  }, /*#__PURE__*/React__default.createElement("input", {
    ref: ref,
    type: "checkbox",
    checked: props.checked,
    onChange: props.onChange,
    disabled: props.disabled
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "IlDataTableV3Checkbox-Checkbox"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "checked"
  }, /*#__PURE__*/React__default.createElement(IlIcon, {
    name: "gs-check",
    size: 12
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "indeterminate"
  }, /*#__PURE__*/React__default.createElement(IlIcon, {
    name: "gs-minus",
    size: 12
  }))));
}

export { IlDataTableV3Checkbox as default };
